!(function () {
    const HONEYCOMB_USER_COOKIE_NAME = '__hcmbid';
    const COOKIES_EXPIRE_IN_YEARS = 5;

    const getRandomString = len => {
        let s = '';
        const randomChar = () => {
            var n = Math.floor(Math.random() * 62);
            if (n < 10) return n; // 1-10
            if (n < 36) return String.fromCharCode(n + 55); // A-Z
            return String.fromCharCode(n + 61); // a-z
        };
        while (s.length < len) s += randomChar();
        return s;
    };

    const setCookie = (cookieName, cookieValue, expireYears) => {
        const expireDate = new Date();
        expireDate.setFullYear(expireDate.getFullYear() + expireYears);
        document.cookie =
            cookieName +
            '=' +
            escape(cookieValue) +
            (expireYears == null ? '' : '; expires=' + expireDate.toUTCString());
    };

    const getCookie = name => {
        const existingCookie = document.cookie.split('; ').find(c => c.startsWith(name + '='));
        return existingCookie && existingCookie.split('=')[1];
    };

    // get user session id from cookies to store it in db
    let cookieSessionId = getCookie(HONEYCOMB_USER_COOKIE_NAME);

    // create cookie if it does not exist
    if (cookieSessionId === undefined) {
        const randomString = getRandomString(36);
        setCookie(HONEYCOMB_USER_COOKIE_NAME, randomString, COOKIES_EXPIRE_IN_YEARS);
        cookieSessionId = randomString;
    }

    // All the partners contains '__st' variable in sources with product info
    if (__st) {
        var productId = __st.rid;
        var uri = new URL(document.currentScript.src);
        var productVisitUrl = uri.origin + '/shops/visits';
        var shopUrl = uri.searchParams.get('shop');
        if (window.location.href.indexOf('/products/') > -1 && productId && shopUrl) {
            fetch(productVisitUrl, {
                method: 'post',
                body: JSON.stringify({ productId, shopUrl, cookie: cookieSessionId }),
            }).catch(error => {
                console.error('Ping unsuccessful', error);
            });
        }
    }
})();
